import React, { ReactNode } from 'react';
import './toolbar.scss'
interface Props {
    children?: ReactNode;
    items: ReactNode[];
    text: string;
}

const ToolBar: React.FC<Props> = ({ children, items, text }) => {
    return (
        <div className="sa-toolbar row between middle">
            <h1 className='sa-toolbar-text'>{text}</h1>
            {children}
            <menu className="items-container">
                {items.map((item, i) => {
                    return (
                        <div className="sm-mar-right" key={`toolbar-menu-items--${i}`}>
                            {item}
                        </div>
                    );
                })}
            </menu>
        </div>
    );
};

export default ToolBar;
